import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "bootstrap5/src/css/bootstrap.min.css";
import "bootstrap5/src/js/bootstrap.bundle.min.js";
import Header from "./componets/Header";
import Footer from "./componets/Footer";
import MainPage from "./componets/MainPage";
import Terms from "./componets/Terms";
import Privacypolicy from "./componets/Privacypolicy";
import Registration from "./componets/Registration";
import Contact from "./componets/Contact";
import ProgramDetails from "./componets/Admin/ProgramDetails";
import PaymentSuccess from "./componets/PaymentSuccess";
import PaymentInstructions from "./componets/PaymentInstructions";
import PaymentError from "./componets/PaymentError";
import PaymentCancel from "./componets/PaymentCancel";
import { useEffect, useState } from "react";
import ScrollToTop from "./components/ScrollToTop";


import Aboutus from "./componets/Aboutus";


import "./style.css";
function Layout({ children }) {
  return (
    <>
      <Header />
      <div>{children}</div>
      <Footer />
    </>
  );
}

// Protected route component
function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if admin is logged in
    const checkAuth = () => {
      const adminToken = localStorage.getItem("adminToken");
      setIsAuthenticated(!!adminToken);
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/admin/login" />;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* User Routes */}
        <Route
          path="/"
          element={
            <Layout>
              <MainPage />
            </Layout>
          }
        />
          <Route
          path="about"
          element={
            <Layout>
              <Aboutus />
            </Layout>
          }
        />
        <Route
          path="/program/:id"
          element={
            <Layout>
              <ProgramDetails />
            </Layout>
          }
        />

        <Route
          path="/:path/registration"
          element={
            <Layout>
              <Registration />
            </Layout>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />

        <Route
          path="/termsandconditions"
          element={
            <Layout>
              <Terms />
            </Layout>
          }
        />

        <Route
          path="/privacypolicy"
          element={
            <Layout>
              <Privacypolicy />
            </Layout>
          }
        />

        {/* Payment Flow Routes */}
        <Route
          path="/payment-instructions"
          element={
            <Layout>
              <PaymentInstructions />
            </Layout>
          }
        />

        <Route
          path="/payment-success"
          element={
            <Layout>
              <PaymentSuccess />
            </Layout>
          }
        />

        <Route
          path="/payment-error"
          element={
            <Layout>
              <PaymentError />
            </Layout>
          }
        />

        <Route
          path="/payment-cancel"
          element={
            <Layout>
              <PaymentCancel />
            </Layout>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;
